import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@/shared/lib/classnames/cn';
import type { VariantProps } from 'class-variance-authority';
const underlineVariants = cva('relative inline-block', {
  variants: {
    direction: {
      leftToRight: 'group',
      rightToLeft: 'group',
      center: 'group'
    }
  },
  defaultVariants: {
    direction: 'leftToRight'
  }
});
const lineVariants = cva('absolute bottom-0 left-0 w-full transition-transform duration-300', {
  variants: {
    direction: {
      leftToRight: 'origin-left scale-x-0 group-hover:scale-x-100',
      rightToLeft: 'origin-right scale-x-0 group-hover:scale-x-100',
      center: 'origin-center scale-x-0 group-hover:scale-x-100'
    },
    size: {
      sm: 'h-px',
      md: 'h-0.5',
      lg: 'h-1'
    }
  },
  defaultVariants: {
    direction: 'leftToRight',
    size: 'sm'
  }
});
interface UnderlineEffectProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof underlineVariants>, VariantProps<typeof lineVariants> {
  asChild?: boolean;
  color?: string;
}
const UnderlineEffect = React.forwardRef<HTMLSpanElement, UnderlineEffectProps>(({
  className,
  direction,
  size,
  asChild = false,
  color = 'bg-gray-500',
  children,
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'span';
  return <Comp className={cn(underlineVariants({
    direction,
    className
  }))} ref={ref} {...props}>
        {children}
        <span className={cn(lineVariants({
      direction,
      size
    }), color)} />
      </Comp>;
});
UnderlineEffect.displayName = 'UnderlineEffect';
export { UnderlineEffect };